import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateFormatES',
  standalone: true
})
export class DateFormatPipe implements PipeTransform {
  transform(value: any): any {
    if (!value) { return null; }
    const fecha = new Date(value);
    fecha.setMinutes(fecha.getMinutes() + fecha.getTimezoneOffset());
    const meses = [
      'Ene',
      'Feb',
      'Mar',
      'Abr',
      'May',
      'Jun',
      'Jul',
      'Ago',
      'Sep',
      'Oct',
      'Nov',
      'Dic',
    ];
    const dia = fecha.getDate();
    const mes = meses[fecha.getMonth()];
    const anio = fecha.getFullYear();

    return `${dia} ${mes} ${anio}`;
  }
}

@Pipe({
  name: 'linkify',
  standalone: true
})
export class LinkifyPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) { return value; }
    const urlRegex = /((?:https?:\/\/)?(?:www\.)?[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+(?::\d+)?(?:\/[^\s]*)?(?:\?[^\s]*)?(?:#[^\s]*)?)/gi;
    return value.replace(urlRegex, (url) => {
      const href = url.match(/^(https?:\/\/|www\.)/) ? (url.match(/^(www\.)/) ? `http://${url}` : url) : `https://${url}`;
      return `<a class="underline" href="${href}" target="_blank">${url}</a>`;
    });
  }
}
